import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ThisIsApril from "../../components/Portfolio/ThisIsApril"

const ThisIsAprilPage = ({ location }) => (
  <Layout location={location}>
    <SEO title="Home" keywords={[`BMR`, `labels`]} />
    <ThisIsApril />
  </Layout>
)

export default ThisIsAprilPage
